import { BaseRouteService } from 'core/services';

class OrderRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'orders/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}

	getUnlinkedOrderLines(filter) {
		return super.create(this.base + 'unlinked', filter);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	replace(replaceParams, sourceOfChange) {
		return super.get(this.base + 'replacement/sourceOfChange={sourceOfChange}', replaceParams, { sourceOfChange });
	}

	createOrdersBulk(resource, sourceOfChange) {
		return super.create(this.base + 'create-orders-bulk/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	}

	validateOrderAddress(resource) {
		return super.update(this.base + 'verify-order-address', resource);
	}

	getDistinctValues() {
		return super.create(this.base + 'get-distinct-values');
	}

	updateOrderInfo(resource, sourceOfChange) {
		return super.update(this.base + 'update-order-info/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	}

	cancelMarketplaceOrder(resource, sourceOfChange) {
		return super.update(this.base + 'cancel/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	}

	uncancelMarketplaceOrder(resource, sourceOfChange) {
		return super.update(this.base + 'uncancel/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	}

	onHold(onHoldParams, sourceOfChange) {
		return super.update(this.base + 'on-hold/?sourceOfChange={sourceOfChange}', onHoldParams, { sourceOfChange });
	}

	updateOrderType(params, sourceOfChange) {
		return super.update(this.base + '{id}/update-order-type/?sourceOfChange={sourceOfChange}', params, {sourceOfChange});
	}
}

export default OrderRouteService;
